import React, { useEffect, useState } from "react";

import { CloseGreyIcon } from "../../../assets/icons";
import { PlanBasicInfoDTO } from "../../../models/plan/plan.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import { planService } from "../../../services/planService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { CreatePlanSubscriptionDTO } from "../../../models/PlanSubscription/planSubscription.request";
import { planSubscriptionService } from "../../../services/planSubscriptionService";
import Loader from "../../shared/Loader";

interface ConfirmModalProps {
    localName: string;
    localId: string;
    onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ localName, localId, onClose }) => {

    const [plans, setPlans] = React.useState<PlanBasicInfoDTO[]>([]);
    const [selectedPlanId, setSelectedPlanId] = useState<string>("");
    const [isCustomPackageSelected, setIsCustomPackageSelected] = useState<boolean>(false);
    const [plan, setPlan] = useState<CreatePlanSubscriptionDTO>({
        isActive: true,
        description: "",
        planId: "",
        localId: localId
    });

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchPlans();
    }, []);


    const handleCreateSubscription = async () => {
        if (!localId) {
            notify("error", "ID lokala nije dostupan");
            return;
        }

        if(!selectedPlanId) {
            notify("error", "Morate izabrati plan");
            return;
        }

        if(!isCustomPackageSelected) {
            setPlan({
                ...plan,
                startDate: undefined,
                endDate: undefined,
                pricePerPeriod: undefined
            });
        }


        setLoading(true);
        try {
            const response = await planSubscriptionService.create({
                ...plan,
                planId: selectedPlanId,
                localId: localId
            });

            if (response.success) {
                notify("success", "Članarina uspešno obnovljena");
                onClose();
            } else {
                notify("error", response.message || "Greška pri obnavljanju članarine");
            }
        } catch (error) {
            notify("error", "Greška pri obnavljanju članarine");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const fetchPlans = async () => {
        if (!localId) {
            notify("error", "ID lokala nije dostupan");
            return;
        }

        setLoading(true);
        try {
            const response = await planService.getBasicInfo();

            if (response.success && response.data) {
                setPlans(response.data);
            } else {
                notify("error", response.message || "Greška pri učitavanju planova");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju planova");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    // const showPicker = () => {
    //     const input: any = document.getElementById('manual-date');
    //     if (input && input.showPicker) {
    //         input.showPicker();
    //     }
    // };

    if(loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section membership-renewal">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Obnovi članarinu korisnika</div>
                                <div className="description-text">Obnovite brzim biranjem ili unosom datuma do koga će važiti članarina</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Obnova za lokal</label>
                                    <div className="input-div">
                                        <div>{localName}</div>
                                    </div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Brzo biranje plana</label>
                                    <div className="membership-renewal-quick-access-list">

                                        {plans.map((plan) => (
                                            <div key={plan.id} className={`small-box-div pointer ${selectedPlanId === plan.id ? "green-bg" : ""}`}
                                                onClick={() => { setSelectedPlanId(plan.id) }}
                                            >
                                                <div>{plan.name} - {plan.durationDays} dana - {plan.price}din</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Komentar</label>
                                    <textarea placeholder="" className="form-textarea grey w-input"></textarea>
                                </div>
                                <div className="modal-form-div">
                                    <div className={`small-box-div pointer ${isCustomPackageSelected ? "green-bg" : ""}`} onClick={() => {
                                        setIsCustomPackageSelected(!isCustomPackageSelected);
                                        setSelectedPlanId("");
                                    }}>
                                        <div>Custom vrednosti paketa</div>
                                    </div>
                                </div>
                                {isCustomPackageSelected && (
                                    <>
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Početak važenja</label>
                                                <input className="form-input grey w-input" type="date"
                                                onChange={(e) => setPlan({
                                                    ...plan,
                                                    description: plan.description,
                                                    isActive: plan.isActive,
                                                    localId: plan.localId,
                                                    planId: plan.planId,
                                                    startDate: new Date(e.target.value)
                                                })}
                                            />
                                        </div>
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Kraj važenja</label>
                                            <input className="form-input grey w-input" type="date"
                                                onChange={(e) => setPlan({
                                                    ...plan,
                                                    description: plan.description,
                                                    isActive: plan.isActive,
                                                    localId: plan.localId,
                                                    planId: plan.planId,
                                                    endDate: new Date(e.target.value)
                                                })}
                                            />
                                            <div className="description-text">{plan.startDate && plan.endDate && plan.endDate > plan.startDate ? `${(plan.endDate.getTime() - plan.startDate.getTime()) / (1000 * 3600 * 24)} dana` : ""}</div>
                                        </div>
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Cena</label>
                                            <input className="form-input grey w-input" placeholder="" type="number"
                                                value={plan.pricePerPeriod}
                                                onChange={(e) => setPlan({
                                                    ...plan,
                                                    description: plan.description,
                                                    isActive: plan.isActive,
                                                    localId: plan.localId,
                                                    planId: plan.planId,
                                                    pricePerPeriod: parseFloat(e.target.value)
                                                })}
                                            />
                                        </div>
                                    </>
                                )}
                            </form>
                        </div>

                        <div className="modal-buttons" onClick={onClose}>
                            <div className="button-secondary medium">
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={() => handleCreateSubscription()}>
                                <div>Produži članarinu</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    );
};

export default ConfirmModal;